import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setRecommendation({ commit }, data) {
    commit(types.SET_RECOMMENDATION, data)
  },
  async getRecommendations({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getRecommendations', () => http.get('report/getReportRecommendations'))
    commit(types.SET_RECOMMENDATIONS, r.data)
    return r.data
  },
  async saveRecommendation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveRecommendation', () => http.post('report/saveReportRecommendation', data))
    return r.data
  },
  async deleteRecommendation({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteRecommendation', () => http.get(`report/removeReportRecommendation?reportRecommendation=${id}`))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/recommendations/actions.js